import React from "react"
import PropTypes from "prop-types"

import DiscreteSelect from "selects/components/DiscreteSelect"
import PDFViewer from "app/static/frontend/components/PDFViewer"
import isEqual from "lodash.isequal"

/*
 * Wrapper component around PDFViewer which takes the language_pdf_urls dict
 * of a BillText object and provides a selector for switching between the
 * display language
 */
export default class DiscreteSelectPDFWrapper extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        formatOptions: PropTypes.func.isRequired,
        getDefault: PropTypes.func.isRequired,
        getUrl: PropTypes.func.isRequired,
        options: PropTypes.object.isRequired,
    }

    state = {
        option: null,
        url: null,
    }

    componentDidMount() {
        if (!this.state.option) {
            this.setOption()
        }
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.options, this.props.options)) {
            this.setOption()
        }
    }

    setOption = () => {
        const defaultOption = this.props.getDefault(this.props.options)

        this.setState({
            option: defaultOption,
            url: this.props.getUrl({ options: this.props.options, selected: defaultOption }),
        })
    }

    // Creates an array of { value, label } objects for the language selector.
    getOptions = () => this.props.formatOptions(this.props.options)

    // Change handler to update option and URL on selection change.
    changeOption = ({ value }) =>
        this.setState({
            option: value,
            url: this.props.getUrl({ options: this.props.options, selected: value }),
        })

    render() {
        return (
            <div className={this.props.className}>
                {Object.keys(this.props.options).length > 1 && (
                    <div className="form-select-field" style={{ marginTop: "0px" }}>
                        <DiscreteSelect
                            getItems={this.getOptions}
                            onChange={this.changeOption}
                            value={this.state.option}
                            clearable={false}
                        />
                    </div>
                )}
                <PDFViewer className={this.props.className} url={this.state.url} key={this.state.url} />
            </div>
        )
    }
}
